// Genera y descarga el PDF de un lote de cupones recién creado.
//
// Mismo patrón que financialReportPdf.ts: react-pdf entra por import()
// DINÁMICO (las ~1.5MB del renderer + fuentes solo bajan al apretar
// "Descargar PDF"), client-side sin infra nueva. Misma advertencia de
// portabilidad a Node (fuentes como assets de Vite) — ver ese archivo.

import type { CouponBatchResult } from '@/lib/api';

export function couponsPdfFilename(batch: CouponBatchResult): string {
  return `cupones-${batch.partner_id}-${batch.batch_id.slice(0, 8)}.pdf`;
}

export async function downloadCouponsPdf(args: {
  batch: CouponBatchResult;
  partnerLabel: string;
  generatedBy: string;
}): Promise<void> {
  const [{ pdf }, { default: CouponsPdfDoc }] = await Promise.all([
    import('@react-pdf/renderer'),
    import('@/lib/pdf/CouponsPdfDoc'),
  ]);

  const blob = await pdf(
    CouponsPdfDoc({
      batch: args.batch,
      partnerLabel: args.partnerLabel,
      generatedBy: args.generatedBy,
    }),
  ).toBlob();

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = couponsPdfFilename(args.batch);
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Diferido: revocar en el mismo tick cancela la descarga en algunos browsers.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
